import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import InputFormSearchIcon from '../../../Icon/Svg/InputFormSearchIcon';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import Hover from '../../../Ui/System/Hover';
const SlideSearchListKeywordInput = (props) => {
    const { keyword, keywordRef, loading, onUpdateKeyword } = props;
    const onKeyDown = useCallback((e) => {
        if (e.keyCode !== 229 && e.key === 'Enter') {
            onUpdateKeyword();
        }
    }, [onUpdateKeyword]);
    return (_jsx("div", Object.assign({ className: 'slide_search_list_keyword_input' }, { children: _jsx(Hover, { children: _jsxs("div", Object.assign({ className: 'input_form_keyword' }, { children: [_jsx("input", { className: 'input_text', defaultValue: keyword, name: 'keyword', onKeyDown: onKeyDown, ref: keywordRef, type: 'search' }, keyword), _jsx(SubmitButton, { buttonType: 'button', className: 'button', isDisabled: loading, isLoading: loading, onClick: onUpdateKeyword, text: _jsx(InputFormSearchIcon, { className: 'white' }) })] })) }) })));
};
SlideSearchListKeywordInput.propTypes = {
    keyword: propStr().isRequired,
    keywordRef: propShape().isRequired,
    loading: propBool().isRequired,
    onUpdateKeyword: propFunc().isRequired,
};
export default SlideSearchListKeywordInput;
